import { Grid } from "@mui/material";
import FormCard from "./FormCard";

export default function AffectTypes({ setAffectType }) {
  return (
    <>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <FormCard
            title="Ja jestem osobą, która potrzebuje pomocy w tej sytuacji"
            subtitle="Jestem bezpośrednim uczestnikiem sytuacji, którą chcę zgłosić. Czuję się poszkodowany/a."
            onClick={() => setAffectType(0)}
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <FormCard
            title="Nie jestem osobą, która potrzebuje pomocy w tej sytuacji – zgłaszam ją w sprawie innej osoby"
            subtitle="Wiem o sytuacji, którą chcę zgłosić, ale nie czuję się w niej poszkodowany/a. Uważam, że to inna osoba doznała krzywdy."
            onClick={() => setAffectType(1)}
          />
        </Grid>
      </Grid>
    </>
  );
}
